import React from 'react';
import { Text } from '@wix/design-system';
import { translate } from '#packages/i18n';
import { frames } from '#packages/panels';
import { connectWithScope } from '#packages/apilib';

import * as utils from '../utils';
import { getComponentCtaActions } from './componentsCtaActions';
import { DeprecationOverlayScope } from '../scope';
import styles from './deprecatedComponentPanel.scss';

interface DeprecatedComponentModalOwnProps {
  panelName: string;
  compType: string;
}

type DeprecatedComponentModalProps = DeprecatedComponentModalOwnProps &
  ReturnType<typeof mapDispatchToProps>;

const DeprecatedComponentPanel: React.FC<DeprecatedComponentModalProps> = ({
  panelName,
  compType,
  onCancel,
  onConfirm,
}) => {
  const deprecationData = utils.getDeprecationData(compType);
  const translationKeys = deprecationData?.TRANSLATIONS?.MODAL;

  if (!deprecationData || !translationKeys) {
    return null;
  }
  return (
    <frames.MessagePanelFrame
      panelName={panelName}
      className={styles.deprecationOverlayModalPanel}
      dataHook="deprecated-component-modal"
      title={translate(translationKeys.TITLE)}
      onConfirm={onConfirm}
      confirmLabel={translate(translationKeys.MAIN_BUTTON)}
      onCancel={onCancel}
      cancelLabel={translate(translationKeys.SECONDARY_BUTTON)}
    >
      <Text>{translate(translationKeys.BODY)}</Text>
    </frames.MessagePanelFrame>
  );
};

const mapDispatchToProps = (
  scope: DeprecationOverlayScope,
  ownProps: DeprecatedComponentModalOwnProps,
) => {
  const editorAPI = scope.editorAPI;

  const actions = getComponentCtaActions(editorAPI, ownProps.compType);

  return {
    onCancel: actions.onCancel,
    onConfirm: actions.onConfirm,
  };
};

export default connectWithScope(
  () => DeprecationOverlayScope,
  DeprecatedComponentPanel,
  null,
  mapDispatchToProps,
);
